/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetExperteerPreferencesResponse,
  HTTPValidationError,
  UpdateSearchStatus200,
  UpdateSearchStatusBody,
} from './platformapi.schemas';

import getExperteerPreferencesMutator from '../custom-axios-instance';
import updateSearchStatusMutator from '../custom-axios-instance';

/**
 * Retrieves the ExperteerPreferences object for the current user
 * @summary Get Experteer Preferences
 */
export const getExperteerPreferences = (signal?: AbortSignal) => {
  return getExperteerPreferencesMutator<GetExperteerPreferencesResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/dashboard/experteer/preferences`,
    method: 'GET',
    signal,
  });
};

export const getGetExperteerPreferencesQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/dashboard/experteer/preferences`] as const;
};

export const getGetExperteerPreferencesQueryOptions = <
  TData = Awaited<ReturnType<typeof getExperteerPreferences>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getExperteerPreferences>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetExperteerPreferencesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getExperteerPreferences>>> = ({
    signal,
  }) => getExperteerPreferences(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getExperteerPreferences>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetExperteerPreferencesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getExperteerPreferences>>
>;
export type GetExperteerPreferencesQueryError = void | HTTPValidationError;

export function useGetExperteerPreferences<
  TData = Awaited<ReturnType<typeof getExperteerPreferences>>,
  TError = void | HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getExperteerPreferences>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExperteerPreferences>>,
          TError,
          Awaited<ReturnType<typeof getExperteerPreferences>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetExperteerPreferences<
  TData = Awaited<ReturnType<typeof getExperteerPreferences>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getExperteerPreferences>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExperteerPreferences>>,
          TError,
          Awaited<ReturnType<typeof getExperteerPreferences>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetExperteerPreferences<
  TData = Awaited<ReturnType<typeof getExperteerPreferences>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getExperteerPreferences>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Experteer Preferences
 */

export function useGetExperteerPreferences<
  TData = Awaited<ReturnType<typeof getExperteerPreferences>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getExperteerPreferences>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetExperteerPreferencesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Allows the current user to set their search status
 * @summary Update Search Status
 */
export const updateSearchStatus = (
  updateSearchStatusBody: UpdateSearchStatusBody,
  signal?: AbortSignal,
) => {
  return updateSearchStatusMutator<UpdateSearchStatus200>({
    url: `${import.meta.env['VITE_API_HOST']}/dashboard/experteer/preferences/update_search_status`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: updateSearchStatusBody,
    signal,
  });
};

export const getUpdateSearchStatusMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSearchStatus>>,
    TError,
    { data: UpdateSearchStatusBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSearchStatus>>,
  TError,
  { data: UpdateSearchStatusBody },
  TContext
> => {
  const mutationKey = ['updateSearchStatus'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSearchStatus>>,
    { data: UpdateSearchStatusBody }
  > = (props) => {
    const { data } = props ?? {};

    return updateSearchStatus(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSearchStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSearchStatus>>
>;
export type UpdateSearchStatusMutationBody = UpdateSearchStatusBody;
export type UpdateSearchStatusMutationError = void | HTTPValidationError;

/**
 * @summary Update Search Status
 */
export const useUpdateSearchStatus = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateSearchStatus>>,
      TError,
      { data: UpdateSearchStatusBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateSearchStatus>>,
  TError,
  { data: UpdateSearchStatusBody },
  TContext
> => {
  const mutationOptions = getUpdateSearchStatusMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
